module.exports = __webpack_public_path__ + "img/from-account-filter.eb7e883d.png";